import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { MainCard, MainCardProps } from '../layoutPages/components/MainCard';
import { PageTitle } from '../layoutPages/components/PageTitle';
import { DottedList } from '../layoutPages/containers/DottedList';
import { MainCards } from '../layoutPages/containers/MainCards';
import { Paragraph } from '../layoutPages/containers/Paragraphs/Paragraph';
import { DefaultSetting } from '../layoutPages/defaultSetting';
import WebIcon from '@mui/icons-material/Web';
import { MaterialList, MaterialWithLink } from '../layoutPages/components/MaterialList';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';

export const EventCardData2425: Array<MainCardProps> = [
    {
        caption: "港島童軍繽紛日2024",
        src: "https://lh3.googleusercontent.com/pw/AP1GczM-C_6FpJqvAielByf7TmLUZerI_IBURRIN8BGUsxs1dt_yz_5cD9oQY_9p3gu5sOgtv-cDUonBErpHTql0h__qgdpPTGLwPmlk1yL8aTEnfiOIVx5wQYfhoHycjtAhCTW4uvQBfSDvQ0YiKYVyWhc3=w1219-h914-s-no?authuser=0",
        onClick: () => window.open("https://photos.app.goo.gl/Rk3S5e6vkpPiWNtw9", '_blank', 'noopener,noreferrer')
    },
    {
        caption: "童軍宣誓",
        src: "https://lh3.googleusercontent.com/pw/AP1GczPPC2e3pzoDdsxHekupnxHTkBlS1VOnDf9OMFCqG6Of2Ua7mr0kAtuTvLZR924cYaXDfmFA1xumR9oo3el3kcVn20-Qa-uoArqaIpUQQbY4_ufrCKBmgdPA1NpAJZjLfpEujjbaHkqaS2pSwhrU7j9k=w1371-h914-s-no?authuser=1",
        onClick: () => window.open("https://photos.app.goo.gl/FGmwJbtkr7ENkWmM8", '_blank', 'noopener,noreferrer')
    },
]

export const EventCardData2324: Array<MainCardProps> = [
    {
        caption: "童軍宣誓及20週年旅慶",
        src: "https://lh3.googleusercontent.com/pw/AP1GczP_c7D5t_i1FxQUnbMNtjwyeSn__rCTyrVBRlCFc6agmSkTo-GrSLO0CQC0TSQSccoGFL6MMV_iwwrDoXL0TGpYaeKkqtClpS3dJNfcHuTv4CIdEADqffK-HbYL9ve0fbxhzb2GboYbCSNzWTBOhwsT=w1439-h959-s-no-gm?authuser=0",
        onClick: () => window.open("https://photos.app.goo.gl/gzgedAcbWvGgq9LF6", '_blank', 'noopener,noreferrer')
    },
    {
        caption: "幼童軍金紫荊宿營活動",
        src: "https://lh3.googleusercontent.com/pw/AP1GczO16sxS1Fv53WOMiKfJSGTloWw6kg-ZdJlPfeAx3lsdfmgBAulZarXFEGw0lZwKUNagNCcZ1Dn-0HYcNB93k1K4Xi2JnP8E6K5WiEjmZhjEBmnQKx4AN77ZF4Un-pFistOVA-Gdnm23qCCylf6OrgIr=w1279-h959-s-no-gm?authuser=0",
        onClick: () => window.open("https://photos.app.goo.gl/trYNnfrqfqV8iYAYA", '_blank', 'noopener,noreferrer')
    },
];

export const EventCardData1819: Array<MainCardProps> = [
    {
        caption: "烏溪沙考驗營",
        src: "http://www.pkps.edu.hk/photo/10052019/images/image/005-_DSC2248.JPG",
        onClick: () => window.open("http://www.pkps.edu.hk/photo/10052019/index.html", '_blank', 'noopener,noreferrer')
    },
    {
        caption: "幼童軍燒烤活動",
        src: "http://www.pkps.edu.hk/photo/02012019/images/image/16-IMG_0060.JPG",
        onClick: () => window.open("http://www.pkps.edu.hk/photo/02012019/index.html", '_blank', 'noopener,noreferrer')
    },
    {
        caption: "幼童軍宣誓典禮",
        src: "http://www.pkps.edu.hk/photo/18122018/images/fullsize/17-IMG_0020.JPG.JPG",
        onClick: () => window.open("http://www.pkps.edu.hk/photo/18122018/index.html", '_blank', 'noopener,noreferrer')
    },
    {
        caption: "國際電訊日嘉年華",
        src: "http://www.pkps.edu.hk/photo/27102018/images/image/11-L1010056.JPG",
        onClick: () => window.open("http://www.pkps.edu.hk/photo/27102018/index.html", '_blank', 'noopener,noreferrer')
    },

];

export function PageScout() {

    const isPc = useMediaQuery('(min-width:600px)');

    let notice: Array<MaterialWithLink> = [
        {
            name: "通告",
            src: "http://www.pkps.edu.hk/newhtml/news/Jan/pta2.pdf",
            icon: <PictureAsPdfIcon sx={{ color: "red" }} />
        },
    ];

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2} sx={{ backgroundColor: DefaultSetting.mainBackgroundColor }} >
            <Grid item xs={11} sm={10} >
                <PageTitle title='1275旅幼童軍' size='h3' />
                <MainCard src="http://www.pkps.edu.hk/img/website/scout/home.jpg" sx={{ mt: 2 }} noImgPopup={true} />


                <PageTitle title='活動相簿' size='h3' sx={{ pt: 3 }} />

                <Paragraph title="2024-2025年度"
                    data={[
                            <MainCards height="250px" gridItemSm={3} data={EventCardData2425}  />
                    ]}
                />

                <Paragraph title="2023-2024年度"
                    data={[
                            <MainCards height="250px" gridItemSm={3} data={EventCardData2324} justifyContent="flex-start" />
                    ]}
                />

                <Paragraph title="2018-2019年"
                    data={[
                            <MainCards height="250px" gridItemSm={3} data={EventCardData1819} />
                    ]}
                />

                <MaterialList data={[{
                    name: "查看以往的活動相片",
                    src: "http://www.pkps.edu.hk/newhtml/tj.html",
                    icon: <WebIcon sx={{ color: "blue" }} />,
                }]} />

                {/* <br></br><br></br>

                <PageTitle title='家長義工資訊' size='h3' sx={{ py: 3 }} />

                <MaterialList data={notice} /> */}


            </Grid>
        </Grid>
    )
}
